export const FSFNotAvailableLightBoxActions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
};